import type { TemplateResult, TemplateSettings } from "./types";

/** SHA-256 of a file's bytes, hex-encoded. Used to key per-image progress in localStorage. */
export async function hashFile(file: File): Promise<string> {
  const buf = await file.arrayBuffer();
  const digest = await crypto.subtle.digest("SHA-256", buf);
  const bytes = new Uint8Array(digest);
  let hex = "";
  for (let i = 0; i < bytes.length; i++) hex += bytes[i].toString(16).padStart(2, "0");
  return hex;
}

/** Convert a TemplateResult cell index (row*grid + col) into row/col, useful for click handling. */
export function cellAt(result: TemplateResult, x: number, y: number, cellPx: number, originX: number, originY: number): number | null {
  const col = Math.floor((x - originX) / cellPx);
  const row = Math.floor((y - originY) / cellPx);
  if (row < 0 || row >= result.grid || col < 0 || col >= result.grid) return null;
  return row * result.grid + col;
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revoke after a tick so the click handler can pick up the URL.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function downloadFilename(originalName: string, settings: TemplateSettings): string {
  const stem = originalName.replace(/\.[^.]+$/, "");
  return `${stem}_${settings.grid}x${settings.grid}.png`;
}
